module.exports = __webpack_public_path__ + "static/media/device_background.37e179fa.png";